import { CONTAINERS } from '../variables/containers';
import { BREAKPOINTS } from '../variables/breakpoints';
import { forOwn } from 'lodash';
/* USAGE */

/*
import styled from 'styled-components';
import { setContainer } from '@titelmedia/bricks-theme/lib/utilities/layout';

export const Container = styled.div`
  ${setContainer({size: 'lg'})}
`;
// possible values: 'sm', 'md', 'lg'
*/

export var setContainer = function setContainer(_ref) {
  var size = _ref.size;
  var style = "\n    padding: 0px 20px;\n    margin: 0 auto;\n  ";
  var useSize = size || 'md';

  if (CONTAINERS[useSize]) {
    style += "max-width: ".concat(CONTAINERS[useSize].mobile, ";");
    forOwn(BREAKPOINTS, function (b, breakpointKey) {
      style += "\n          @media (min-width: ".concat(b, "px) {\n              max-width: ").concat(CONTAINERS[useSize][breakpointKey], ";\n          }\n      ");
    });
  }

  return style;
};